import React from 'react';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import { createMessagesGetter } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import deepEquals from 'Lib/Object/deepEquals';
import { ChartFieldSection } from 'Components/Layout';

let ChartSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const chart = useSelector(createWorksheetSelector!('Chart'));
  const chartMessages = useSelector(
    pipe(createWorksheetSelector!('Messages'), createMessagesGetter('Chart')),
    deepEquals
  );

  return chart === null ? null : (
    <ChartFieldSection
      chart={chart}
      messages={chartMessages?.map((m: any) => ({ message: m.Text, severity: m.MessageType.toLowerCase() }))}
    />
  );
};
ChartSection = withInjectedProps(ChartSection);

export { ChartSection };
export default ChartSection;
